import React, {Component, useContext} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import NGLContext from "../NGLContext";
import CenteredTabs from './CenteredTabs'


const styles = theme => ({
    root: {},
    expansionDetail: {
        padding: 0,
    },
    expansionSummaryIcon: {
        top: 'auto',
        position: 'absolute',
        right: 'auto',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)',
        },
    },
});

const ExpansionPanel = withStyles({
    root: {
        position: 'initial',
        '&$expanded': {
            margin: 'auto',
        },
    },
    // minHeight: 40,
    expanded: {
        margin: '0 !important',
    },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
    root: {
        // backgroundColor: 'rgba(0,0,0,.08)',
        // borderBottom: '1px solid rgba(0,0,0,.125)',
        // marginBottom: -1,
        minHeight: 40,
        '&$expanded': {
            minHeight: 40,
        },
    },
    expanded: {},
})(props => <MuiExpansionPanelSummary {...props} />);

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';


@withStyles(styles)
class BottomPanel extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <ExpansionPanel
                            expanded={contextNGL.bottomPanelExpanded}
                            onChange={contextNGL.handleBottomPanel}
                        >
                            <ExpansionPanelSummary
                                expandIcon={<MoreHorizIcon/>}
                                IconButtonProps={{
                                    disableRipple: true,
                                    className: classes.expansionSummaryIcon
                                }}
                            >
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                                className={classes.expansionDetail}
                            >
                                <CenteredTabs/>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>
        );
    }
}

export default BottomPanel;